export const optionsPosada = [
  { label: 'Предсідник Cкобиного Кругу', value: 1 },
  { label: 'Заступник голови КБ УПЮ', value: 2 },
  { label: 'Писар', value: 3 },
  { label: 'Референт виховних частин', value: 4 },
  { label: 'Референт кадри виховників і виховниць', value: 5 },
  { label: 'Референт вишколі', value: 6 },
  { label: 'Референт спеціалізованого пластування', value: 7 },
  { label: 'Референт вмілостей', value: 8 },
  { label: 'Референт табірництва', value: 9 },
  { label: 'Референт третьої проби', value: 10 },
  { label: 'Референт програми УПЮ', value: 11 },
  { label: 'Інше', value: 12 },
]


// WEBPACK FOOTER //
// ./src/constants/global.js